<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <PageTitle></PageTitle>
        <b-card>
          <div class="bd-example">
            <dl class="row">
              <dt class="col-sm-3">{{ $t('page.generic.code') }}</dt>
              <dd class="col-sm-9">{{procedureType.code}}</dd>
              <dt class="col-sm-3">{{ $t('page.generic.name') }}</dt>
              <dd class="col-sm-9">{{procedureType.label}}</dd>
              <dt class="col-sm-3">{{ $t('page.generic.description') }}</dt>
              <dd class="col-sm-9">{{ procedureType.description }}</dd>
            </dl>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <button v-if="isProcedureStandaloneMode" class="btn btn-danger float-right padder" variant="danger" @click="deleteModal = true"
                      type="button">
                {{ $t('actions.delete') }}
              </button>
              <router-link v-if="procedureType.id && isProcedureStandaloneMode" class="btn btn-primary float-right" role="button"
                           :to="{name: 'procedureTypeEditRoute', params: {id:procedureType.id}}">
                {{ $t('actions.edit') }}
              </router-link>
              <!-- Modal Component -->
              <b-modal title="Eliminazione Tipologia Prestazione" class="modal-danger" v-model="deleteModal" @ok="deleteProcedureType"
                       ok-variant="danger">
                {{ $t('page.generic.deleteMessage', {n: procedureType.code}) }}
              </b-modal>
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import miniToastr from 'mini-toastr' //ES6
import PageTitle from '@/components/PageTitle'
import ProcedureTypeService from "@/services/ProcedureTypeService";
import Costants from "@/constants";

const procedureTypeService = ProcedureTypeService.build();

export default {
  name: 'ProcedureTypeShow',
  props: {
    id: {
      required: true
    }
  },
  components: {
    PageTitle,
  },
  data() {
    return {
      deleteModal: false,
      procedureType: {}
    }
  },
  created() {
    miniToastr.init(); // config can be passed here miniToastr.init(config)
    miniToastr.setIcon('error', 'i', {'class': 'fas fa-exclamation-triangle'});
    this.fetchData()
  },
  computed: {
    isProcedureStandaloneMode: function() {
      return JSON.parse(localStorage.getItem('configurations')).procedureMode === Costants.PROCEDURE_STANDALONE_MODE
    }
  },
  methods: {
    async fetchData() {
      this.procedureType = await procedureTypeService.read(this.id)
    },
    async deleteProcedureType() {
      try {
        // TODO Verificare cancellazione solo se non associata ad altre prestazioni
        await procedureTypeService.destroy(this.id);
        this.$router.replace({name: 'procedureTypeRoute'});
        miniToastr.info("Tipologia Prestazione cancellata con successo!")
      } catch (exception) {
        miniToastr.error(exception.message)
      }
    }
  }
}
</script>
